<div class="group-search">
  <div class="search-row">
    <mat-icon fontSet="material-icons-round" class="search-icon">search</mat-icon>
    <input
      class="search-input"
      type="text"
      placeholder="Search groups by name or number"
      [value]="searchTerm"
      (input)="onSearchInput($event)"
    />
  </div>

  <div class="results" *ngIf="!isLoading">
    <div
      class="result-row"
      *ngFor="let group of filteredGroups"
      [class.selected]="isSelected(group)"
      (click)="toggleOption(group)"
    >
      <div class="primary">
        <mat-icon fontSet="material-icons-round" class="group-icon">groups</mat-icon>
        <span class="ksubtitle-medium name">{{ group.buildingName }}</span>
        <span class="klabel-medium identifier" *ngIf="group.buildingNumber">#{{ group.buildingNumber }}</span>
      </div>
      <mat-icon
        *ngIf="isSelected(group)"
        fontSet="material-icons-round"
        class="check-icon"
      >check_circle</mat-icon>
      <mat-icon
        *ngIf="!isSelected(group)"
        fontSet="material-icons-round"
        class="uncheck-icon"
      >radio_button_unchecked</mat-icon>
    </div>

    <div class="empty-state klabel-medium" *ngIf="filteredGroups.length === 0">
      No groups match your search.
    </div>
  </div>

  <div class="loading klabel-medium" *ngIf="isLoading">
    Loading groups...
  </div>
</div>
